/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, AuthBaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { XFoundHttpClient } from '@/core/components/authentication/http/abstractions/xfound.httpclient';

import { GetPostleitzahlzuordnungByNameResponse as AceXFoundPortalCoreCaqPostleitzahlzuordnungQueriesGetPostleitzahlzuordnungByNameResponse } from '../models/ace/xFound/Portal/Core/CAQ/Postleitzahlzuordnung/Queries/get-postleitzahlzuordnung-by-name-response';

@Injectable({
providedIn: 'root',
})

export class PostleitzahlzuordnungService extends BaseService {
constructor(
config: ApiConfiguration,
http: HttpClient,
authHttp: XFoundHttpClient
) {
super(config, http, authHttp);
}

  /**
   * Path part for operation apiPostleitzahlzuordnungGetPostleitzahlzuordnungByNameGet
   */
  static readonly ApiPostleitzahlzuordnungGetPostleitzahlzuordnungByNameGetPath = '/api/Postleitzahlzuordnung/GetPostleitzahlzuordnungByName';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPostleitzahlzuordnungGetPostleitzahlzuordnungByNameGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPostleitzahlzuordnungGetPostleitzahlzuordnungByNameGet$Plain$Response(params?: {
    Name?: string;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqPostleitzahlzuordnungQueriesGetPostleitzahlzuordnungByNameResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PostleitzahlzuordnungService.ApiPostleitzahlzuordnungGetPostleitzahlzuordnungByNameGetPath, 'get');
    if (params) {
      rb.query('Name', params.Name, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/plain',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqPostleitzahlzuordnungQueriesGetPostleitzahlzuordnungByNameResponse>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPostleitzahlzuordnungGetPostleitzahlzuordnungByNameGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPostleitzahlzuordnungGetPostleitzahlzuordnungByNameGet$Plain(params?: {
    Name?: string;
  }): Observable<AceXFoundPortalCoreCaqPostleitzahlzuordnungQueriesGetPostleitzahlzuordnungByNameResponse> {

    return this.apiPostleitzahlzuordnungGetPostleitzahlzuordnungByNameGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqPostleitzahlzuordnungQueriesGetPostleitzahlzuordnungByNameResponse>) => r.body as AceXFoundPortalCoreCaqPostleitzahlzuordnungQueriesGetPostleitzahlzuordnungByNameResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPostleitzahlzuordnungGetPostleitzahlzuordnungByNameGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPostleitzahlzuordnungGetPostleitzahlzuordnungByNameGet$Response(params?: {
    Name?: string;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqPostleitzahlzuordnungQueriesGetPostleitzahlzuordnungByNameResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PostleitzahlzuordnungService.ApiPostleitzahlzuordnungGetPostleitzahlzuordnungByNameGetPath, 'get');
    if (params) {
      rb.query('Name', params.Name, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqPostleitzahlzuordnungQueriesGetPostleitzahlzuordnungByNameResponse>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPostleitzahlzuordnungGetPostleitzahlzuordnungByNameGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPostleitzahlzuordnungGetPostleitzahlzuordnungByNameGet(params?: {
    Name?: string;
  }): Observable<AceXFoundPortalCoreCaqPostleitzahlzuordnungQueriesGetPostleitzahlzuordnungByNameResponse> {

    return this.apiPostleitzahlzuordnungGetPostleitzahlzuordnungByNameGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqPostleitzahlzuordnungQueriesGetPostleitzahlzuordnungByNameResponse>) => r.body as AceXFoundPortalCoreCaqPostleitzahlzuordnungQueriesGetPostleitzahlzuordnungByNameResponse)
    );
  }

  /**
   * Path part for operation apiPostleitzahlzuordnungGetAllBundeslaenderGet
   */
  static readonly ApiPostleitzahlzuordnungGetAllBundeslaenderGetPath = '/api/Postleitzahlzuordnung/GetAllBundeslaender';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPostleitzahlzuordnungGetAllBundeslaenderGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPostleitzahlzuordnungGetAllBundeslaenderGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, PostleitzahlzuordnungService.ApiPostleitzahlzuordnungGetAllBundeslaenderGetPath, 'get');
    if (params) {
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/plain',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPostleitzahlzuordnungGetAllBundeslaenderGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPostleitzahlzuordnungGetAllBundeslaenderGet$Plain(params?: {
  }): Observable<Array<string>> {

    return this.apiPostleitzahlzuordnungGetAllBundeslaenderGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPostleitzahlzuordnungGetAllBundeslaenderGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPostleitzahlzuordnungGetAllBundeslaenderGet$Response(params?: {
  }): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, PostleitzahlzuordnungService.ApiPostleitzahlzuordnungGetAllBundeslaenderGetPath, 'get');
    if (params) {
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPostleitzahlzuordnungGetAllBundeslaenderGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPostleitzahlzuordnungGetAllBundeslaenderGet(params?: {
  }): Observable<Array<string>> {

    return this.apiPostleitzahlzuordnungGetAllBundeslaenderGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

}